import { ACCESS_GROUPS, matchesAccessGroupRule } from "../../access-control/models/access-groups.models";
import { ADMIN_FEATURE_KEYS, FEATURE_KEYS } from "../../access-control/models/role-feature.models";
import type { AdminSidebarFeatureSection } from "../models/admin.models";

export const ADMIN_ENTRY_ACCESS_RULES = [
  { featureKeys: ADMIN_FEATURE_KEYS },
  { groups: { anyOf: [ACCESS_GROUPS.Admin] } },
  { featureKey: FEATURE_KEYS.TQ_ADMIN, groups: { anyOf: [ACCESS_GROUPS.Admin, ACCESS_GROUPS.VesselPerformance] } },
] as const;

export const hasAdminSidebarFeatureSectionAccess = (
  section: AdminSidebarFeatureSection,
  groups: readonly string[],
  hasFeature: (featureKey: string) => boolean,
): boolean => {
  if (!matchesAccessGroupRule(groups, section.requiredGroups)) {
    return false;
  }

  if (section.requiredGroups && section.requiredFeatureKeys.length === 0) {
    return true;
  }

  if (section.requiredFeatureKeys.some(hasFeature)) {
    return true;
  }

  return (
    section.additionalAccessRules?.some(
      (rule) => rule.featureKeys.some(hasFeature) && matchesAccessGroupRule(groups, rule.requiredGroups),
    ) ?? false
  );
};
